export default __webpack_public_path__ + "images/0xdc2de2f2c0122ff7cb8482dc47da75a6a5d1a88b.png";